import set from "lodash.set"
import merge from "lodash.merge"
import snakeCase from "lodash.snakecase"
import { pascalCase as makePascalCase } from "pascal-case"

const deepClone = str => {
	return JSON.parse(JSON.stringify(str))
}

const pascalCase = str => {
	return makePascalCase(str)
}

const toTechnicalString = str => {
	if (!str) return ""
	return snakeCase(str)?.toUpperCase() ?? ""
}

const generateId = (length = 8) => {
	let result = ""
	let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
	let charactersLength = characters.length
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength))
	}
	return result
}

const generateDataFromDataSchema = dataSchema => {
	const copyOfDataSchema = deepClone(dataSchema)

	const generatePaths = (arr, path = "root", parent) => {
		arr.forEach((item, index) => {
			let newPath

			newPath = parent?.dataType === "array" ? `${path}[${index}]` : `${path}.${item.label}`

			pathsAndValues.push({
				path: newPath,
				value: item?.dataType !== "array" && item?.dataType !== "object" ? item?.value : null
			})

			if (item?.children?.length) generatePaths(item.children, newPath, item)
		})
	}

	const pathsAndValues = []
	generatePaths(copyOfDataSchema)

	const objs = []
	pathsAndValues.forEach(item => objs.push(set({}, item?.path, item?.value)))
	return merge({}, ...objs)?.root
}

const downloadFile = (byteArray, fileName, type) => {
	let bytes = new Uint8Array(byteArray)
	let blob = new Blob([bytes], { type: type })
	let link = document.createElement("a")
	link.href = window.URL.createObjectURL(blob)
	link.download = fileName
	link.click()
}

export { deepClone, pascalCase, toTechnicalString, generateId, generateDataFromDataSchema, downloadFile }
